import React from 'react';
import { ApolloQueryResult } from '@apollo/client';
import { AntiFraud, AntiFraudQuery,AntiFraudQueryVariables, BorrowerPosition } from 'generated/graphql';

export interface IAntiFraudContext {
    antiFraud: AntiFraud,
    borrowerPosition: BorrowerPosition,
    refetch(variables?: AntiFraudQueryVariables): Promise<ApolloQueryResult<AntiFraudQuery>>
}

const AntiFraudContext = React.createContext<IAntiFraudContext>(null);

const AntiFraudd: React.FC<IAntiFraudContext> = ({ antiFraud, borrowerPosition, refetch, children }) => (
    <AntiFraudContext.Provider value={{
        antiFraud,
        borrowerPosition,
        refetch,
    }}>
        { children}
    </AntiFraudContext.Provider>
);

export default AntiFraudd;

export {
    AntiFraudContext,
};
